import { Helper } from "../util/helper.js";
import { Config } from "../config/config.js";
import { Button } from "./button.js";
import { HTTPService, JsonResultClass } from "../util/httpManager.js";
import { FAIcon } from "./faIcon.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import React from "react";

const processUrl = (url: string, Activated: boolean, baseUrl: string, version: string, userRole: string) => {
    if (!Activated)
        return null;

    return Helper.processTemplate(url, (matches) => {
        switch (matches) {
            case "helpBaseUrl":
                return baseUrl;
            case "helpVersion":
                return version;
            case "helpUserRole":
                return userRole;
            case "helpLanguage":
                switch (Config.user.languageId) {
                    case 0:
                        return "de";
                    case 1:
                    default:
                        return "en"
                }
            default:
                return "";
        }
    });
}

export default class IFrame extends React.Component<IFrameProps, IFrameState>{
    constructor(props: IFrameProps) {
        super(props);
        this.state = {
            paramters: null
        }
        this.loadParameters();
    }

    private loadParameters = async () => {
        const { Code, Data, Message } = await HTTPService.noBusyIndicator().get<JsonResultClass<HelpViewModel>>("Help/GetTemplateData");
        if (Code == 0)
            this.setState({ paramters: Data });
        else
            NotificationHelper.showErrorMessage(Message);
    }

    private changePartOfUrl(urlToChange: string): string {
        let replaceUrl = urlToChange;
        if (urlToChange.match("kontexthilfe")) {
            replaceUrl = urlToChange.replace("kontexthilfe", "user");
        }
        return replaceUrl;
    }

    private openUrl = (url: string) => {
        const openUrl = this.changePartOfUrl(url);
        window.open(openUrl);
        window.focus();
    }

    private getUrl = () => {
        const url: string = Helper.isNullOrEmpty(this.props.helpUrl) ? this.props.url : this.props.helpUrl;
        const paramters = this.state.paramters;
        return processUrl(url, paramters.Activated, paramters.BaseUrl, paramters.Version, paramters.UserRole)
    }

    render() {
        if (Helper.hasValue(this.state.paramters)) {
            const url = this.getUrl()
            return !Helper.isNullOrEmpty(url) ? (
                <>
                    <iframe id="iframe_id" key={url} src={url} style={{ height: '100%', width: '100%' }}></iframe >
                    <div style={{ position: 'absolute', right: '38px', bottom: '21px' }}>
                        <Button buttonStyle={{ minWidth: '20px', height: '20px', fontSize: '10pt' }} iconName="link" title="Link" handleClick={() => {this.openUrl(url)} } />
                    </div>
                </>) : null
        }

        return <div style={{ width: "100%", height: "25%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ width: "fit-content", height: "fit-content" }}>
                <FAIcon name="spinner" prefix={"fas"} spins={true} attributes={["spin", "3x"]} style={{ color: "#767676" }} />
            </div>
        </div>;
    }
}

interface IFrameState {
    paramters: HelpViewModel;
}
interface HelpViewModel {
    Activated: boolean;
    BaseUrl: string;
    Version: string;
    UserRole: string;
}
export interface IFrameProps {
    url: string;
    helpUrl?: any;
}